import { SwitchButton } from '@components/core-ui/form-elements/buttons/Button/variations/SwitchButton';
import { Header } from '@components/Header';
import { HeaderSwitchWrapper } from '@components/Header/components/HeaderSwitchWrapper';
import { routes } from '@routes';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router';
import { Content } from './components/Content';
import { PageProvider } from './providers/PageProvider';

export const NotificationSettingsPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Notification Settings - AutoScript</title>
      </Helmet>
      <Header
        title="Notification Settings"
        leftSideContent={[
          <HeaderSwitchWrapper key="tabSwitcher">
            <SwitchButton
              onClick={() => {
                navigate(routes.notifications.make());
              }}
            >
              Notifications
            </SwitchButton>
            <SwitchButton
              active
              onClick={() => {
                navigate(routes.notificationSettings.make());
              }}
            >
              Settings
            </SwitchButton>
          </HeaderSwitchWrapper>,
        ]}
      />

      <PageProvider>
        <Content />
      </PageProvider>
    </>
  );
};
